import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import OrderedBySelect from '../components/OrderedBySelect';
import AttorneySelect from '../components/AttorneySelect';
import InsuranceCompanySelect from '../components/InsuranceCompanySelect';
import AdjusterSelect from '../components/AdjusterSelect';
import StopLocationSelect from '../components/StopLocationSelect';
import TypeOfRecordSelect from '../components/TypeOfRecordSelect';
import QuestionSelect from '../components/QuestionSelect';

const API_URL = process.env.REACT_APP_API_URL || '';

// ── Constants ────────────────────────────────────────────────────────────────

const TEXAS_COUNTIES = [
  "Anderson","Andrews","Angelina","Aransas","Archer","Armstrong","Atascosa","Austin",
  "Bailey","Bandera","Bastrop","Baylor","Bee","Bell","Bexar","Blanco","Borden","Bosque",
  "Bowie","Brazoria","Brazos","Brewster","Briscoe","Brooks","Brown","Burleson","Burnet",
  "Caldwell","Calhoun","Callahan","Cameron","Camp","Carson","Cass","Castro","Chambers",
  "Cherokee","Childress","Clay","Cochran","Coke","Coleman","Collin","Collingsworth",
  "Colorado","Comal","Comanche","Concho","Cooke","Coryell","Cottle","Crane","Crockett",
  "Crosby","Culberson","Dallam","Dallas","Dawson","Deaf Smith","Delta","Denton","DeWitt",
  "Dickens","Dimmit","Donley","Duval","Eastland","Ector","Edwards","El Paso","Ellis",
  "Erath","Falls","Fannin","Fayette","Fisher","Floyd","Foard","Fort Bend","Franklin",
  "Freestone","Frio","Gaines","Galveston","Garza","Gillespie","Glasscock","Goliad",
  "Gonzales","Gray","Grayson","Gregg","Grimes","Guadalupe","Hardeman","Hardin","Harris",
  "Harrison","Hartley","Haskell","Hays","Hemphill","Henderson","Hidalgo","Hill","Hockley",
  "Hood","Hopkins","Houston","Howard","Hudspeth","Hunt","Hutchinson","Irion","Jack",
  "Jackson","Jasper","Jeff Davis","Jefferson","Jim Hogg","Jim Wells","Johnson","Jones",
  "Karnes","Kaufman","Kendall","Kenedy","Kent","Kerr","Kimble","King","Kinney","Kleberg",
  "Knox","Lamar","Lamb","Lampasas","La Salle","Lavaca","Lee","Leon","Liberty","Limestone",
  "Lipscomb","Live Oak","Llano","Loving","Lubbock","Lynn","Madison","Marion","Martin",
  "Mason","Matagorda","Maverick","McCulloch","McLennan","McMullen","Medina","Menard",
  "Midland","Milam","Mills","Mitchell","Montague","Montgomery","Moore","Morris","Motley",
  "Nacogdoches","Navarro","Newton","Nolan","Nueces","Ochiltree","Oldham","Orange","Palo Pinto",
  "Panola","Parker","Parmer","Pecos","Polk","Potter","Presidio","Rains","Randall","Reagan",
  "Real","Red River","Reeves","Refugio","Roberts","Robertson","Rockwall","Runnels","Rusk",
  "Sabine","San Augustine","San Jacinto","San Patricio","San Saba","Schleicher","Scurry",
  "Shackelford","Shelby","Sherman","Smith","Somervell","Starr","Stephens","Sterling",
  "Stonewall","Sutton","Swisher","Tarrant","Taylor","Terrell","Terry","Throckmorton",
  "Titus","Tom Green","Travis","Trinity","Tyler","Upshur","Upton","Uvalde","Val Verde",
  "Van Zandt","Victoria","Walker","Waller","Ward","Washington","Webb","Wharton","Wheeler",
  "Wichita","Wilbarger","Willacy","Williamson","Wilson","Winkler","Wise","Wood","Yoakum",
  "Young","Zapata","Zavala",
];

const CASE_TYPES = ['DISTRICT','COUNTY','JUSTICE OF THE PEACE','FEDERAL'];
const OBTAIN_BY = ['Subpoena Duces Tecum - Admissible','Authorization','HIPAA'];
const BILL_TO_OPTIONS = ['Law Firm w/Insurance Rate','Law Firm','Insurance Company','Client'];
const WO_STATUSES = ['Pending','In Progress','Completed','On Hold','Cancelled'];
const INV_STATUSES = ['Draft','Sent','Paid'];
const TAB_LABELS = ['Case Details','Attorneys','Stop Location','Work Order Update','Work Order Pg 2','Invoice'];

const EMPTY_CASE = {
  cause_number:'', clerk_no:'', type_of_case:'', county:'', court_number:'',
  obtain_records_by:'', style_plaintiff:'', style_defendant:'',
  ordered_by:'', ordered_by_email:'', order_date:'', date_needed:'',
  file_number:'', rush_order:false,
  patient_name:'', patient_last_name:'', patient_dob:'', patient_ssn:'', patient_drivers_license:'',
  bill_to:'', insurance_company:'', adjuster_name:'', adjuster_email:'',
  insurance_address:'', claim_number:'', insured:'', date_of_loss:'',
};

const EMPTY_WO = {
  stop_location_name:'', stop_location_add1_name:'', stop_location_attention:'',
  stop_location_type_records:'', record_date_from:'', record_date_to:'',
  stop_location_include_prior_dates:false, stop_location_include_to_present:false,
  stop_location_address:'', stop_location_addr2:'', stop_location_city_state_zip:'',
  stop_location_phone:'', stop_location_fax:'', stop_location_email:'',
  stop_location_website:'', stop_location_contact:'', stop_location_agent_of_service:'',
  stop_location_service_type:'', stop_location_requirements:'', stop_location_notes:'',
  question_text:'',
  legal_tech:'', status:'Pending', status_date:'',
  next_call_date:'', served_date:'', set_date:'', waiver_date:'', closed_date:'', cancel_date:'',
  notes:'', add1_notes:'', general_notes:'',
  check_number:'', payment_amount:'', payment_date:'', prepay:false, paid_to:'',
  firm_2nd_attorney:'', name_2nd_attorney:'',
  records_check:false, radiology_check:false, rule_11_check:false,
  review_type:'', tracking_number:'', courier:'', courier_note:'',
  notary:false, notary_phone:'', certified:false, certified_text:'', hand_served:false,
  cross_questions:false, amended:false, redirects:false, copies:false,
  pages_count:'', films_count:'', color_pages_count:'', cds_count:'', other_description:'',
  front_check_by:'', back_check_by:'', double_check_by:'', box_number:'', shredded:false,
};

const EMPTY_ATTORNEY = { name:'', firm:'', bar_num:'', addr1:'', addr2:'', city:'', state_code:'', zip:'', phone:'', fax:'', email:'' };
const EMPTY_INVOICE = { invoice_date:'', due_date:'', amount:'', description:'', status:'Draft', notes:'' };

// ── Small helpers ────────────────────────────────────────────────────────────

const ic = (extra = '') => `w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 ${extra}`;

const F = ({ label, value, onChange, type = 'text', options, disabled, className, ...rest }) => (
  <div>
    <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>
    {type === 'select' ? (
      <select value={value || ''} onChange={onChange} disabled={disabled}
        className={ic(disabled ? 'bg-gray-100 text-gray-500' : '') + (className ? ' ' + className : '')} {...rest}>
        <option value="">Select…</option>
        {options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    ) : type === 'textarea' ? (
      <textarea value={value || ''} onChange={onChange} disabled={disabled} rows={3}
        className={ic(disabled ? 'bg-gray-100 text-gray-500' : '') + (className ? ' ' + className : '')} {...rest} />
    ) : (
      <input type={type} value={value || ''} onChange={onChange} disabled={disabled}
        className={ic(disabled ? 'bg-gray-100 text-gray-500' : '') + (className ? ' ' + className : '')} {...rest} />
    )}
  </div>
);

const CB = ({ label, checked, onChange, disabled }) => (
  <label className="flex items-center gap-2 text-sm cursor-pointer">
    <input type="checkbox" checked={!!checked} onChange={onChange} disabled={disabled}
      className="h-4 w-4 text-blue-600 border-gray-300 rounded" />
    {label}
  </label>
);

const SectionCard = ({ title, children, className = '' }) => (
  <div className={`bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4 ${className}`}>
    {title && <h3 className="text-sm font-semibold text-gray-700 mb-3 pb-2 border-b">{title}</h3>}
    {children}
  </div>
);

// ── Main Component ───────────────────────────────────────────────────────────

export default function CauseForm() {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(0);
  const [selectedCase, setSelectedCase] = useState(null);
  const [caseSearch, setCaseSearch] = useState('');
  const [caseSearchResults, setCaseSearchResults] = useState([]);
  const [caseForm, setCaseForm] = useState({ ...EMPTY_CASE });
  const [clientAttorney, setClientAttorney] = useState({ ...EMPTY_ATTORNEY });
  const [opposingAttorney, setOpposingAttorney] = useState({ ...EMPTY_ATTORNEY });
  const [additionalAttorneys, setAdditionalAttorneys] = useState([]);
  const [woForm, setWoForm] = useState({ ...EMPTY_WO });
  const [invoices, setInvoices] = useState([]);
  const [invoiceForm, setInvoiceForm] = useState({ ...EMPTY_INVOICE });
  const [saving, setSaving] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkCount, setBulkCount] = useState(1);
  const [selectedCompanyOriginalId, setSelectedCompanyOriginalId] = useState('');

  const setCase = (field, value) => setCaseForm(f => ({ ...f, [field]: value }));
  const setWo = (field, value) => setWoForm(f => ({ ...f, [field]: value }));
  const setClient = (field, value) => setClientAttorney(f => ({ ...f, [field]: value }));
  const setOpposing = (field, value) => setOpposingAttorney(f => ({ ...f, [field]: value }));

  const isDisabled = !!selectedCase;

  // ── Handlers ────────────────────────────────────────────────────

  const handleCaseSearch = async () => {
    if (!caseSearch.trim()) return;
    try {
      const token = localStorage.getItem('token');
      const q = encodeURIComponent(caseSearch.trim());
      const res = await axios.get(
        `${API_URL}/api/causes?cause_number=${q}&patient_name=${q}&type=all`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCaseSearchResults(res.data || []);
    } catch (err) {
      console.error('Case search failed:', err);
    }
  };

  const selectExistingCase = (c) => {
    setSelectedCase(c);
    setCaseForm({
      cause_number: c.cause_number || '',
      clerk_no: c.clerk_no || '',
      type_of_case: c.type_of_case || '',
      county: c.county || '',
      court_number: c.court_number || '',
      obtain_records_by: c.obtain_records_by || '',
      style_plaintiff: c.style_plaintiff || '',
      style_defendant: c.style_defendant || '',
      ordered_by: c.ordered_by || '',
      ordered_by_email: c.ordered_by_email || '',
      order_date: c.order_date || '',
      date_needed: c.date_needed || '',
      file_number: c.file_number || '',
      rush_order: c.rush_order || false,
      patient_name: c.patient_name || '',
      patient_last_name: c.patient_last_name || '',
      patient_dob: c.patient_dob || '',
      patient_ssn: c.patient_ssn || '',
      bill_to: c.bill_to || '',
      insurance_company: c.insurance_company || '',
      adjuster_name: c.adjuster_name || '',
      adjuster_email: c.adjuster_email || '',
      insurance_address: c.insurance_address || '',
      claim_number: c.claim_number || '',
      insured: c.insured || '',
      date_of_loss: c.date_of_loss || '',
    });
    setCaseSearchResults([]);
  };

  const clearSelectedCase = () => {
    setSelectedCase(null);
    setCaseForm({ ...EMPTY_CASE });
  };

  const clearForm = () => {
    setSelectedCase(null);
    setCaseSearch('');
    setCaseSearchResults([]);
    setCaseForm({ ...EMPTY_CASE });
    setClientAttorney({ ...EMPTY_ATTORNEY });
    setOpposingAttorney({ ...EMPTY_ATTORNEY });
    setAdditionalAttorneys([]);
    setWoForm({ ...EMPTY_WO });
    setInvoices([]);
    setInvoiceForm({ ...EMPTY_INVOICE });
  };

  const addAttorneyToTable = () => {
    const rows = [];
    if (clientAttorney.name || clientAttorney.firm) {
      rows.push({ ...clientAttorney, type: 'Client' });
    }
    if (opposingAttorney.name || opposingAttorney.firm) {
      rows.push({ ...opposingAttorney, type: 'Opposing' });
    }
    if (rows.length > 0) {
      setAdditionalAttorneys(a => [...a, ...rows]);
    }
  };

  const updateAdditionalAtty = (idx, field, value) => {
    setAdditionalAttorneys(a => a.map((row, i) => i === idx ? { ...row, [field]: value } : row));
  };

  const removeAdditionalAtty = (idx) => {
    setAdditionalAttorneys(a => a.filter((_, i) => i !== idx));
  };

  const addInvoice = () => {
    if (!invoiceForm.amount && !invoiceForm.description) return;
    setInvoices(invs => [...invs, { ...invoiceForm, _key: Date.now() }]);
    setInvoiceForm({ ...EMPTY_INVOICE });
  };

  const handleSave = async (count) => {
    setSaving(true);
    setShowBulkModal(false);
    try {
      const payload = {
        ...caseForm,
        work_order_count: count,
        client_attorney: clientAttorney,
        opposing_attorney: opposingAttorney,
        additional_attorneys: additionalAttorneys,
        ...woForm,
        invoices: invoices,
        // If adding WO to existing case, pass existing cause_id
        existing_cause_id: selectedCase ? selectedCase.id : null,
      };
      const token = localStorage.getItem('token');
      const res = await axios.post(`${API_URL}/api/causes`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      navigate(`/causes/${res.data.id}`);
    } catch (err) {
      console.error('Save failed:', err);
      alert('Failed to save: ' + (err.response?.data?.detail || err.message));
    } finally {
      setSaving(false);
    }
  };

  // ── Tab Renderers ────────────────────────────────────────────────

  const renderTab0 = () => (
    <div>
      {/* Search existing case */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <label className="text-sm font-medium text-blue-800">Search Existing Case</label>
        <div className="flex gap-2 mt-1">
          <input
            value={caseSearch}
            onChange={e => setCaseSearch(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleCaseSearch()}
            placeholder="Enter cause number or patient name..."
            className="flex-1 border rounded px-2 py-1 text-sm"
          />
          <button onClick={handleCaseSearch} className="px-3 py-1 bg-blue-600 text-white text-sm rounded">Search</button>
          {selectedCase && (
            <button onClick={clearSelectedCase} className="px-3 py-1 bg-gray-200 text-sm rounded">Clear</button>
          )}
        </div>
        {caseSearchResults.length > 0 && !selectedCase && (
          <div className="mt-2 border rounded bg-white shadow max-h-40 overflow-y-auto">
            {caseSearchResults.map(c => (
              <div key={c.id} onClick={() => selectExistingCase(c)}
                className="px-3 py-2 hover:bg-blue-50 cursor-pointer text-sm border-b last:border-0">
                <span className="font-medium">{c.cause_number}</span>
                {c.patient_name && <span className="text-gray-600"> — {c.patient_name}</span>}
              </div>
            ))}
          </div>
        )}
        {selectedCase && (
          <div className="mt-2 text-sm text-blue-700 font-medium">
            ✓ Adding Work Order to existing case: <strong>{selectedCase.cause_number}</strong>
            {selectedCase.patient_name && ` (${selectedCase.patient_name})`}
          </div>
        )}
      </div>

      {/* Two-column grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* LEFT */}
        <div className="space-y-3">
          <SectionCard title="Court Information">
            <div className="space-y-3">
              <F label="Cause Number" value={caseForm.cause_number} onChange={e => setCase('cause_number', e.target.value)} disabled={isDisabled} placeholder="e.g. 348-356063-24" />
              <F label="Clerk No." value={caseForm.clerk_no} onChange={e => setCase('clerk_no', e.target.value)} disabled={isDisabled} />
              <F label="Type of Case" value={caseForm.type_of_case} onChange={e => setCase('type_of_case', e.target.value)} type="select" options={CASE_TYPES} disabled={isDisabled} />
              <F label="County" value={caseForm.county} onChange={e => setCase('county', e.target.value)} type="select" options={TEXAS_COUNTIES} disabled={isDisabled} />
              <F label="Court Number" value={caseForm.court_number} onChange={e => setCase('court_number', e.target.value)} disabled={isDisabled} placeholder="e.g. 348TH JUDICIAL DISTRICT" />
            </div>
          </SectionCard>
          <SectionCard title="Records & Style">
            <div className="space-y-3">
              <F label="Obtain Records By" value={caseForm.obtain_records_by} onChange={e => setCase('obtain_records_by', e.target.value)} type="select" options={OBTAIN_BY} disabled={isDisabled} />
              <F label="Style (Plaintiff)" value={caseForm.style_plaintiff} onChange={e => setCase('style_plaintiff', e.target.value.toUpperCase())} type="textarea" disabled={isDisabled} />
              <F label="Style (Defendant)" value={caseForm.style_defendant} onChange={e => setCase('style_defendant', e.target.value.toUpperCase())} type="textarea" disabled={isDisabled} />
            </div>
          </SectionCard>
        </div>

        {/* RIGHT */}
        <div className="space-y-3">
          <SectionCard title="Order Details">
            <div className="space-y-3">
              <div>
                <OrderedBySelect
                  label="Ordered By"
                  value={caseForm.ordered_by}
                  onChange={(_id, name, email) => {
                    setCase('ordered_by', name);
                    setCase('ordered_by_email', email);
                  }}
                />
              </div>
              <F label="Ordered By Email" value={caseForm.ordered_by_email} onChange={e => setCase('ordered_by_email', e.target.value)} type="email" disabled={isDisabled} />
              <F label="Order Date" value={caseForm.order_date} onChange={e => setCase('order_date', e.target.value)} type="date" disabled={isDisabled} />
              <F label="Date Needed" value={caseForm.date_needed} onChange={e => setCase('date_needed', e.target.value)} type="date" disabled={isDisabled} />
              <F label="File Number" value={caseForm.file_number} onChange={e => setCase('file_number', e.target.value)} disabled={isDisabled} />
              <div className={`flex items-center gap-2 p-2 rounded ${caseForm.rush_order ? 'bg-red-50 border border-red-200' : ''}`}>
                <CB label="Rush Order" checked={caseForm.rush_order} onChange={e => setCase('rush_order', e.target.checked)} disabled={isDisabled} />
              </div>
            </div>
          </SectionCard>

          <SectionCard title="Patient Information">
            <div className="space-y-3">
              <F label="Patient Full Name" value={caseForm.patient_name} onChange={e => setCase('patient_name', e.target.value)} disabled={isDisabled} />
              <F label="Patient Last Name" value={caseForm.patient_last_name} onChange={e => setCase('patient_last_name', e.target.value)} disabled={isDisabled} />
              <F label="DOB" value={caseForm.patient_dob} onChange={e => setCase('patient_dob', e.target.value)} type="date" disabled={isDisabled} />
              <F label="SSN" value={caseForm.patient_ssn} onChange={e => setCase('patient_ssn', e.target.value)} disabled={isDisabled} />
              <F label="Driver's License" value={caseForm.patient_drivers_license} onChange={e => setCase('patient_drivers_license', e.target.value)} disabled={isDisabled} />
            </div>
          </SectionCard>

          <SectionCard title="Billing & Insurance">
            <div className="space-y-3">
              <F label="Bill To" value={caseForm.bill_to} onChange={e => setCase('bill_to', e.target.value)} type="select" options={BILL_TO_OPTIONS} disabled={isDisabled} />
              <InsuranceCompanySelect
                value={caseForm.insurance_company}
                label="Insurance Company"
                disabled={isDisabled}
                onChange={(id, companyName, address1, cityStZip, originalId) => {
                  setCase('insurance_company', companyName);
                  const addr = [address1, cityStZip].filter(Boolean).join(' ');
                  setCase('insurance_address', addr);
                  setSelectedCompanyOriginalId(originalId || '');
                }}
              />
              <AdjusterSelect
                value={caseForm.adjuster_name}
                label="Adjuster Name"
                disabled={isDisabled}
                companyOriginalId={selectedCompanyOriginalId}
                onChange={(id, name, email, phone) => {
                  setCase('adjuster_name', name);
                  setCase('adjuster_email', email);
                }}
              />
              <F label="Adjuster Email" value={caseForm.adjuster_email} onChange={e => setCase('adjuster_email', e.target.value)} type="email" disabled={isDisabled} />
              <F label="Insurance Address" value={caseForm.insurance_address} onChange={e => setCase('insurance_address', e.target.value)} disabled={isDisabled} />
              <F label="Claim Number" value={caseForm.claim_number} onChange={e => setCase('claim_number', e.target.value)} disabled={isDisabled} />
              <F label="Insured" value={caseForm.insured} onChange={e => setCase('insured', e.target.value)} disabled={isDisabled} />
              <F label="Date of Loss" value={caseForm.date_of_loss} onChange={e => setCase('date_of_loss', e.target.value)} type="date" disabled={isDisabled} />
            </div>
          </SectionCard>
        </div>
      </div>
    </div>
  );

  const renderTab1 = () => {
    const AttyFields = ({ data, setFn, header }) => (
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-semibold text-gray-700 mb-3 pb-1 border-b">{header}</h3>
        <div className="space-y-2">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Name</label>
            <AttorneySelect
              value={data.name}
              label=""
              onChange={(_id, fullName, firmName, phone, email) => {
                setFn('name', fullName || '');
                if (firmName) setFn('firm', firmName);
                if (phone) setFn('phone', phone);
                if (email) setFn('email', email);
              }}
            />
          </div>
          <F label="Firm" value={data.firm} onChange={e => setFn('firm', e.target.value)} />
          <F label="Bar #" value={data.bar_num} onChange={e => setFn('bar_num', e.target.value)} />
          <F label="Addr1" value={data.addr1} onChange={e => setFn('addr1', e.target.value)} />
          <F label="Addr2" value={data.addr2} onChange={e => setFn('addr2', e.target.value)} />
          <div className="grid grid-cols-3 gap-2">
            <F label="City" value={data.city} onChange={e => setFn('city', e.target.value)} />
            <F label="State" value={data.state_code} onChange={e => setFn('state_code', e.target.value)} />
            <F label="Zip" value={data.zip} onChange={e => setFn('zip', e.target.value)} />
          </div>
          <F label="Phone" value={data.phone} onChange={e => setFn('phone', e.target.value)} />
          <F label="Fax" value={data.fax} onChange={e => setFn('fax', e.target.value)} />
          <F label="Email" value={data.email} onChange={e => setFn('email', e.target.value)} type="email" />

        </div>
      </div>
    );

    return (
      <div>
        <div className="flex gap-4 items-start">
          <AttyFields data={clientAttorney} setFn={setClient} header="Client Attorney" />
          <div className="flex flex-col items-center justify-start pt-10">
            <button onClick={addAttorneyToTable}
              className="px-4 py-2 text-white text-sm rounded whitespace-nowrap"
              style={{ backgroundColor: '#1a2744' }}>
              + Add Attorney to Table
            </button>
          </div>
          <AttyFields data={opposingAttorney} setFn={setOpposing} header="Opposing Counsel" />
        </div>

        {additionalAttorneys.length > 0 && (
          <div className="mt-6">
            <h3 className="text-sm font-semibold text-gray-700 mb-2">Additional Attorneys</h3>
            <div className="overflow-x-auto">
              <table className="w-full text-xs border border-gray-200 rounded">
                <thead className="bg-gray-50">
                  <tr>
                    {['Type','Firm','Name','Phone','Fax','Bar #','City','State','Zip',''].map(h => (
                      <th key={h} className="px-2 py-2 text-left font-medium text-gray-600 border-b">{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {additionalAttorneys.map((row, i) => (
                    <tr key={i} className="border-b hover:bg-gray-50">
                      <td className="px-2 py-1">
                        <select value={row.type || 'Client'} onChange={e => updateAdditionalAtty(i, 'type', e.target.value)}
                          className="border rounded px-1 py-0.5 text-xs">
                          <option value="Plaintiff">Plaintiff</option>
                          <option value="Defendant">Defendant</option>
                          <option value="Additional">Additional</option>
                        </select>
                      </td>
                      <td className="px-2 py-1">{row.firm}</td>
                      <td className="px-2 py-1">{row.name}</td>
                      <td className="px-2 py-1">{row.phone}</td>
                      <td className="px-2 py-1">{row.fax}</td>
                      <td className="px-2 py-1">{row.bar_num}</td>
                      <td className="px-2 py-1">{row.city}</td>
                      <td className="px-2 py-1">{row.state_code}</td>
                      <td className="px-2 py-1">{row.zip}</td>

                      <td className="px-2 py-1">
                        <button onClick={() => removeAdditionalAtty(i)}
                          className="text-red-500 hover:text-red-700 text-xs px-1">Remove</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderTab2 = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-3">
        <StopLocationSelect
          value={woForm.stop_location_name}
          label="Stop Location Name"
          onChange={(id, name, addr1, city, state, zip, phone, fax, email, contactName, typeOfRecord, notes) => {
            setWoForm(f => ({
              ...f,
              stop_location_name: name,
              stop_location_address: addr1,
              stop_location_city_state_zip: [city, state, zip].filter(Boolean).join(', '),
              stop_location_phone: phone,
              stop_location_fax: fax,
              stop_location_email: email,
              stop_location_contact: contactName,
                stop_location_notes: notes,
            }));
          }}
        />
        <F label="Add1 Name" value={woForm.stop_location_add1_name} onChange={e => setWo('stop_location_add1_name', e.target.value)} />
        <F label="Attention" value={woForm.stop_location_attention} onChange={e => setWo('stop_location_attention', e.target.value)} />
        <TypeOfRecordSelect
          value={woForm.stop_location_type_records}
          onChange={val => setWoForm(f => ({ ...f, stop_location_type_records: val }))}
        />

        <div className="border rounded p-3 space-y-2 bg-gray-50">
          <p className="text-xs font-medium text-gray-600">Record Dates</p>
          <div className="flex items-center gap-2">
            <div className="flex-1">
              <F label="From" value={woForm.record_date_from} onChange={e => setWo('record_date_from', e.target.value)} type="date" />
            </div>
            <CB label="Include Prior Dates" checked={woForm.stop_location_include_prior_dates}
              onChange={e => setWo('stop_location_include_prior_dates', e.target.checked)} />
          </div>
          <div className="flex items-center gap-2">
            <div className="flex-1">
              <F label="To" value={woForm.record_date_to} onChange={e => setWo('record_date_to', e.target.value)} type="date" />
            </div>
            <CB label="Include to Present" checked={woForm.stop_location_include_to_present}
              onChange={e => setWo('stop_location_include_to_present', e.target.checked)} />
          </div>
        </div>

        <F label="Address" value={woForm.stop_location_address} onChange={e => setWo('stop_location_address', e.target.value)} />
        <F label="Addr2" value={woForm.stop_location_addr2} onChange={e => setWo('stop_location_addr2', e.target.value)} />
        <F label="City / State / Zip" value={woForm.stop_location_city_state_zip} onChange={e => setWo('stop_location_city_state_zip', e.target.value)} />
      </div>

      <div className="space-y-3">
        <F label="Phone" value={woForm.stop_location_phone} onChange={e => setWo('stop_location_phone', e.target.value)} />
        <F label="FAX" value={woForm.stop_location_fax} onChange={e => setWo('stop_location_fax', e.target.value)} />
        <F label="Email" value={woForm.stop_location_email} onChange={e => setWo('stop_location_email', e.target.value)} type="email" />
        <F label="Website" value={woForm.stop_location_website} onChange={e => setWo('stop_location_website', e.target.value)} />
        <F label="Contact" value={woForm.stop_location_contact} onChange={e => setWo('stop_location_contact', e.target.value)} />
        <F label="Agent of Service" value={woForm.stop_location_agent_of_service} onChange={e => setWo('stop_location_agent_of_service', e.target.value)} />
        <F label="Service Type" value={woForm.stop_location_service_type} onChange={e => setWo('stop_location_service_type', e.target.value)} />
        <F label="Requirements" value={woForm.stop_location_requirements} onChange={e => setWo('stop_location_requirements', e.target.value)} />
        <F label="Notes" value={woForm.stop_location_notes} onChange={e => setWo('stop_location_notes', e.target.value)}
          type="textarea" className="bg-yellow-50" />
        <QuestionSelect
          label="Question Text"
          value={woForm.question_text}
          onChange={v => setWoForm(f => ({...f, question_text: v}))}
        />
      </div>
    </div>
  );

  const renderTab3 = () => (
    <div className="space-y-4">
      <SectionCard title="Work Order Update">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <F label="Legal Tech" value={woForm.legal_tech} onChange={e => setWo('legal_tech', e.target.value)} />
          <F label="Status" value={woForm.status} onChange={e => setWo('status', e.target.value)} type="select" options={WO_STATUSES} />
          <F label="Status Date" value={woForm.status_date} onChange={e => setWo('status_date', e.target.value)} type="date" />
        </div>
      </SectionCard>

      <SectionCard title="Dates">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          <F label="Next Call Date" value={woForm.next_call_date} onChange={e => setWo('next_call_date', e.target.value)} type="date" />
          <F label="Served Date" value={woForm.served_date} onChange={e => setWo('served_date', e.target.value)} type="date" />
          <F label="Set Date" value={woForm.set_date} onChange={e => setWo('set_date', e.target.value)} type="date" />
          <F label="Waiver Date" value={woForm.waiver_date} onChange={e => setWo('waiver_date', e.target.value)} type="date" />
          <F label="Closed Date" value={woForm.closed_date} onChange={e => setWo('closed_date', e.target.value)} type="date" />
          <F label="Cancel Date" value={woForm.cancel_date} onChange={e => setWo('cancel_date', e.target.value)} type="date" />
        </div>
      </SectionCard>

      <SectionCard title="Notes">
        <div className="space-y-3">
          <F label="Notes" value={woForm.notes} onChange={e => setWo('notes', e.target.value)} />
          <F label="Add1 Notes" value={woForm.add1_notes} onChange={e => setWo('add1_notes', e.target.value)} type="textarea" />
          <F label="General Notes" value={woForm.general_notes} onChange={e => setWo('general_notes', e.target.value)} type="textarea" className="bg-yellow-50" />
        </div>
      </SectionCard>

      <SectionCard title="Payment">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 items-end">
          <F label="Ck# (99=CC)" value={woForm.check_number} onChange={e => setWo('check_number', e.target.value)} />
          <F label="Amt" value={woForm.payment_amount} onChange={e => setWo('payment_amount', e.target.value)} type="number" />
          <F label="Payment Date" value={woForm.payment_date} onChange={e => setWo('payment_date', e.target.value)} type="date" />
          <div className="flex items-end gap-3 pb-1">
            <CB label="PP Prepay" checked={woForm.prepay} onChange={e => setWo('prepay', e.target.checked)} />
          </div>
          <div className="md:col-span-4">
            <F label="Paid to" value={woForm.paid_to} onChange={e => setWo('paid_to', e.target.value)} />
          </div>
        </div>
      </SectionCard>
    </div>
  );

  const renderTab4 = () => (
    <div className="space-y-4">
      <SectionCard title="2nd Attorney">
        <div className="grid grid-cols-2 gap-3">
          <F label="Firm 2nd Atty" value={woForm.firm_2nd_attorney} onChange={e => setWo('firm_2nd_attorney', e.target.value)} />
          <F label="Name" value={woForm.name_2nd_attorney} onChange={e => setWo('name_2nd_attorney', e.target.value)} />
        </div>
      </SectionCard>

      <SectionCard title="Records & Review">
        <div className="flex flex-wrap gap-4 mb-3">
          <CB label="Records" checked={woForm.records_check} onChange={e => setWo('records_check', e.target.checked)} />
          <CB label="Radiology" checked={woForm.radiology_check} onChange={e => setWo('radiology_check', e.target.checked)} />
          <CB label="Rule 11" checked={woForm.rule_11_check} onChange={e => setWo('rule_11_check', e.target.checked)} />
        </div>
        <F label="Review" value={woForm.review_type} onChange={e => setWo('review_type', e.target.value)} />
      </SectionCard>

      <SectionCard title="Tracking & Service">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <F label="Number" value={woForm.tracking_number} onChange={e => setWo('tracking_number', e.target.value)} />
          <F label="Courier" value={woForm.courier} onChange={e => setWo('courier', e.target.value)} />
          <F label="Courier Note" value={woForm.courier_note} onChange={e => setWo('courier_note', e.target.value)} />
        </div>
        <div className="flex flex-wrap gap-4 mt-3 items-end">
          <CB label="Notary" checked={woForm.notary} onChange={e => setWo('notary', e.target.checked)} />
          {woForm.notary && (
            <div className="flex-1 min-w-[140px]">
              <F label="Phone" value={woForm.notary_phone} onChange={e => setWo('notary_phone', e.target.value)} />
            </div>
          )}
          <CB label="Certified" checked={woForm.certified} onChange={e => setWo('certified', e.target.checked)} />
          {woForm.certified && (
            <div className="flex-1 min-w-[140px]">
              <F label="Certified Text" value={woForm.certified_text} onChange={e => setWo('certified_text', e.target.value)} />
            </div>
          )}
          <CB label="Hand Served" checked={woForm.hand_served} onChange={e => setWo('hand_served', e.target.checked)} />
        </div>
      </SectionCard>

      <SectionCard title="Document Details">
        <div className="flex flex-wrap gap-4 mb-3">
          <CB label="Cross Questions" checked={woForm.cross_questions} onChange={e => setWo('cross_questions', e.target.checked)} />
          <CB label="Amended" checked={woForm.amended} onChange={e => setWo('amended', e.target.checked)} />
          <CB label="Redirects" checked={woForm.redirects} onChange={e => setWo('redirects', e.target.checked)} />
          <CB label="Copies" checked={woForm.copies} onChange={e => setWo('copies', e.target.checked)} />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          <F label="Pages" value={woForm.pages_count} onChange={e => setWo('pages_count', e.target.value)} type="number" />
          <F label="Films" value={woForm.films_count} onChange={e => setWo('films_count', e.target.value)} type="number" />
          <F label="Color Pages" value={woForm.color_pages_count} onChange={e => setWo('color_pages_count', e.target.value)} type="number" />
          <F label="CDs" value={woForm.cds_count} onChange={e => setWo('cds_count', e.target.value)} type="number" />
          <F label="Other Description" value={woForm.other_description} onChange={e => setWo('other_description', e.target.value)} />
        </div>
      </SectionCard>

      <SectionCard title="Production">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 items-end">
          <F label="Front Check By" value={woForm.front_check_by} onChange={e => setWo('front_check_by', e.target.value)} />
          <F label="Back Check By" value={woForm.back_check_by} onChange={e => setWo('back_check_by', e.target.value)} />
          <F label="Double Check By" value={woForm.double_check_by} onChange={e => setWo('double_check_by', e.target.value)} />
          <F label="Box Number" value={woForm.box_number} onChange={e => setWo('box_number', e.target.value)} />
          <div className="flex items-end pb-1">
            <CB label="Shredded" checked={woForm.shredded} onChange={e => setWo('shredded', e.target.checked)} />
          </div>
        </div>
      </SectionCard>
    </div>
  );

  const renderTab5 = () => {
    const total = invoices.reduce((s, inv) => s + (parseFloat(inv.amount) || 0), 0);
    return (
      <div className="space-y-4">
        <div className="bg-blue-50 border border-blue-200 rounded p-3 text-sm text-blue-700">
          Work Order # will be auto-generated on save
        </div>

        <SectionCard title="Add Invoice">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <F label="Invoice Date" value={invoiceForm.invoice_date} onChange={e => setInvoiceForm(f => ({ ...f, invoice_date: e.target.value }))} type="date" />
            <F label="Due Date" value={invoiceForm.due_date} onChange={e => setInvoiceForm(f => ({ ...f, due_date: e.target.value }))} type="date" />
            <F label="Amount" value={invoiceForm.amount} onChange={e => setInvoiceForm(f => ({ ...f, amount: e.target.value }))} type="number" />
            <div className="md:col-span-2">
              <F label="Description" value={invoiceForm.description} onChange={e => setInvoiceForm(f => ({ ...f, description: e.target.value }))} />
            </div>
            <F label="Status" value={invoiceForm.status} onChange={e => setInvoiceForm(f => ({ ...f, status: e.target.value }))} type="select" options={INV_STATUSES} />
            <div className="md:col-span-3">
              <F label="Notes" value={invoiceForm.notes} onChange={e => setInvoiceForm(f => ({ ...f, notes: e.target.value }))} type="textarea" />
            </div>
          </div>
          <button onClick={addInvoice}
            className="mt-3 px-4 py-2 text-white text-sm rounded"
            style={{ backgroundColor: '#1a2744' }}>
            + Add Invoice
          </button>
        </SectionCard>

        {invoices.length > 0 && (
          <SectionCard title="Invoices">
            <table className="w-full text-sm border border-gray-200 rounded">
              <thead className="bg-gray-50">
                <tr>
                  {['Invoice #','Description','Amount','Status','Date','Due Date',''].map((h, i) => (
                    <th key={i} className="px-3 py-2 text-left text-xs font-medium text-gray-600 border-b">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {invoices.map((inv, i) => (
                  <tr key={inv._key || i} className="border-b hover:bg-gray-50">
                    <td className="px-3 py-2 text-xs text-gray-500">pending</td>
                    <td className="px-3 py-2">{inv.description}</td>
                    <td className="px-3 py-2">${parseFloat(inv.amount || 0).toFixed(2)}</td>
                    <td className="px-3 py-2">
                      <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${
                        inv.status === 'Paid' ? 'bg-green-100 text-green-700' :
                        inv.status === 'Sent' ? 'bg-blue-100 text-blue-700' :
                        'bg-gray-100 text-gray-600'
                      }`}>{inv.status}</span>
                    </td>
                    <td className="px-3 py-2">{inv.invoice_date}</td>
                    <td className="px-3 py-2">{inv.due_date}</td>
                    <td className="px-3 py-2">
                      <button onClick={() => removeInvoice(i)} className="text-red-500 hover:text-red-700 text-xs">Remove</button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="bg-gray-50 font-semibold">
                  <td colSpan={2} className="px-3 py-2 text-right text-sm">Total:</td>
                  <td className="px-3 py-2 text-sm">${total.toFixed(2)}</td>
                  <td colSpan={4} />
                </tr>
              </tfoot>
            </table>
          </SectionCard>
        )}
      </div>
    );
  };

  const tabs = [renderTab0, renderTab1, renderTab2, renderTab3, renderTab4, renderTab5];

  // ── Render ───────────────────────────────────────────────────────

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4 flex items-center justify-between">
          <h1 className="text-xl font-bold" style={{ color: '#1a2744' }}>New Order</h1>
          <span className="text-sm text-gray-500">
            {selectedCase
              ? `Adding WO to: ${selectedCase.cause_number}`
              : 'Create New Case & Work Order'}
          </span>
        </div>

        {/* Tab headers */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-4">
          <div className="flex overflow-x-auto">
            {TAB_LABELS.map((label, i) => (
              <button key={i} onClick={() => setActiveTab(i)}
                className={`px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                  activeTab === i
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}>
                <span className={`inline-flex items-center justify-center w-5 h-5 rounded-full text-xs mr-1.5 ${
                  activeTab === i ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-500'
                }`}>{i + 1}</span>
                {label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab content */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          {tabs[activeTab]()}

          {/* Bottom buttons */}
          <div className="flex justify-between items-center mt-6 pt-4 border-t">
            <div className="flex gap-2">
              {activeTab > 0 && (
                <button onClick={() => setActiveTab(t => t - 1)}
                  className="px-4 py-2 bg-gray-100 text-gray-700 rounded text-sm hover:bg-gray-200">
                  ← Previous
                </button>
              )}
              {activeTab < 5 && (
                <button onClick={() => setActiveTab(t => t + 1)}
                  className="px-4 py-2 bg-gray-100 text-gray-700 rounded text-sm hover:bg-gray-200">
                  Next →
                </button>
              )}
            </div>
            <div className="flex gap-2">
              <button onClick={() => navigate('/dashboard')}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded text-sm hover:bg-gray-300">
                Cancel
              </button>
              <button onClick={clearForm}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded text-sm hover:bg-gray-300">
                Clear Form
              </button>
              <button onClick={() => handleSave(1)} disabled={saving}
                className="px-4 py-2 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 disabled:opacity-50">
                {saving ? 'Saving…' : 'Save'}
              </button>
              <button onClick={() => setShowBulkModal(true)} disabled={saving}
                className="px-4 py-2 text-white rounded text-sm disabled:opacity-50"
                style={{ backgroundColor: '#1a2744' }}>
                Save &amp; Copy
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bulk WO modal */}
      {showBulkModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-xl">
            <h3 className="font-bold text-lg mb-3">How many work orders?</h3>
            <p className="text-sm text-gray-600 mb-4">Creates consecutive WO numbers as placeholders (1–60)</p>
            <input
              type="number" min="1" max="60" value={bulkCount}
              onChange={e => setBulkCount(Math.min(60, Math.max(1, parseInt(e.target.value) || 1)))}
              className="w-full border rounded px-3 py-2 text-lg text-center mb-4"
            />
            <div className="flex gap-2">
              <button onClick={() => setShowBulkModal(false)}
                className="flex-1 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300">
                Cancel
              </button>
              <button onClick={() => handleSave(bulkCount)} disabled={saving}
                className="flex-1 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50">
                {saving ? 'Creating…' : `Create ${bulkCount} WO${bulkCount > 1 ? 's' : ''}`}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
